export const JIRA_BASE = 'https://contentsquare.atlassian.net/browse';
